<template>
  <div class="RfDeviceSettings lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="RfDeviceSettings-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="RfDeviceSettings-main lxn-pos-rel">
      <div class="RfDeviceSettings-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.AddIrDevice_title1}}
          </template>
          <template v-slot:body>
            <div class="RfDeviceSettings-wrapper-name-text lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddIrDevice_text1}}
            </div>
            <div class="lxn-w100">
              <customInput @focus="input1State='active'" @blur="input1State=''" :inputState="input1State" v-model="DeviceName" bgColor="#FFFFFF" :placeHolder="$store.getters.language.texts.AddIrDevice_namePlaceHolder" inputType="text" />
            </div>
          </template>
        </TitleBox>
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.IrDeviceSettings_title3}}
          </template>
          <template v-slot:body>
            <div class="RfDeviceSettings-wrapper-button lxn-margin-auto lxn-w100">
              <CustomButton @click="showRemote" bgColor="#1EA5DE" iconRight="remoteController" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true" :disabled="isNodeOffline">
                {{$store.getters.language.texts.IrDeviceSettings_showRemote}}
              </CustomButton>
            </div>
          </template>
        </TitleBox>
        <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
          <template v-slot:title>
            {{$store.getters.language.texts.RfDeviceSettings_title1}}
          </template>
          <template v-slot:body>
            <div class="RfDeviceSettings-wrapper-fieldTitles lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
              {{$store.getters.language.texts.AddIrDevice_text2}}
            </div>
            <div class="lxn-w100 lxn-text lxn-text-center" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
              {{targetDevice.name}}
            </div>
            <div class="RfDeviceSettings-wrapper-button lxn-margin-auto lxn-w100">
              <CustomButton @click="pairDevice" bgColor="#1EA5DE" iconRight="remoteController" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true" :disabled="isNodeOffline">
                {{$store.getters.language.texts.AddRfDevice_testDevice}}
              </CustomButton>
            </div>
          </template>
        </TitleBox>
      </div>
      <div class="RfDeviceSettings-button lxn-margin-auto lxn-w100">
        <CustomButton @click="saveChanges" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.AddRfDevice_button}}
        </CustomButton>
      </div>
      <div class="RfDeviceSettings-button lxn-margin-auto lxn-w100">
        <CustomButton @click="deleteOutput" bgColor="#F36C4F" iconRight="arrowRight" iconRightColor="#F36C4F" iconRightBgColor="#F5C7BD" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.RfDeviceSettings_button2}}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import CustomButton from '@/components/CustomButton.vue'
import TitleBox from '@/components/TitleBox.vue'
import CustomInput from '@/components/CustomInput.vue'
import NODE8 from '@/statics/devices/Node8/header.js'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'

export default {
  name: 'RfDeviceSettings',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    CustomInput,
  },
  data: function () {
    var node = this.$store.getters.getNodeByUUID(this.$route.params.nodeUUID);
    var output = node.outputs[this.$route.params.outputIndex];
    return {
      node: node,
      DeviceName: '',
      input1State: '',
      targetDeviceType: output.settings.deviceType,
      targetDeviceId: output.settings.deviceId,
      targetDevice: NODE8.devices[output.settings.deviceType],
    }
  },
  mounted: function () {
    this.DeviceName = this.output.name;
  },
  watch: {
    targetDeviceType: function (){
      this.targetBrand = 0;
      this.targetModel = 0;
    },
  },
  computed: {
    hub: function () {
      return this.$store.getters.getHubByUUID(this.node.hubUUID);
    },
    output: function () {
      return this.node.outputs[this.$route.params.outputIndex];
    },
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.node.color];
    },
    isNodeOffline: function () {
      if(this.node.connectionStatus == 1){
        return false;
      }else{
        return true;
      }
    },
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    boxStyle: function (boxIndex) {
      return "background-color: " + this.$store.state.themeMainColors[boxIndex];
    },
    showRemote: function () {
      this.$router.push('/showRfRemote/' + this.node.uuid + '/' + this.$route.params.outputIndex);
    },
    pairDevice: function () {
      this.$store.commit('setAppBusy', true);
      var messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: this.hub.psk,
        destinationUUID: this.hub.uuid,
        sourceUUID: this.$store.state.user.uuid
      });
      var learnPacket = [...this.targetDeviceId, ...this.targetDevice.learnPacket];
      var endSeq = [0, 0];
      if(this.targetDevice.endThrUs != 0){
        endSeq = [this.targetDevice.beforeEnd ? this.targetDevice.highThrUs : this.targetDevice.lowThrUs, this.targetDevice.endThrUs];
      }
      var rfPacket = messagingHook.irf.generateIrfByteStream(messagingHook.irf.generateRawData(learnPacket, this.targetDevice.lowThrUs, this.targetDevice.highThrUs, this.targetDevice.startSeq, endSeq));

      this.$store.dispatch('setNodesParameters', {
        messagingHook: messagingHook,
        hubUUID: this.hub.uuid,
        nodeUUID: this.node.uuid,
        bodyContent: {
          nodeActions: [
            {
              nodeUUID: this.node.uuid,
              actions: [
                {
                  parameterId: NODE8.RF.PARAMETER_ID,
                  valueOfChange: messagingHook.utility.arrayTo64(rfPacket),
                  typeOfAction: CONFIGS.ACTION_TYPE_SET,
                  timeDelay: 0
                }
              ]
            },
          ]
        }
      })
      .then( () => {
        this.$store.commit('setAppBusy', false);
      })
      .catch( response => {
        if(response.rejectCode == 1){
          this.$router.push('/SettingsNodeError');
        }else if(response.rejectCode == 2){
          this.$router.push('/SettingsHubError');
          this.$store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
        }
        this.$store.commit('setAppBusy', false);
      });
    },
    saveChanges: function () {
      this.input1State = '';
      if(this.DeviceName == ''){
        this.input1State = 'error';
        alert(this.$store.getters.language.texts.IrDeviceSettings_alert1);
      }else{
        this.$store.commit('setAppBusy', true);
        this.$store.commit('editDeviceOutput', {
          nodeIndex: this.node.index,
          outputIndex: this.$route.params.outputIndex,
          output: {
            name: this.DeviceName,
            settings: {
              deviceId: this.targetDeviceId,
              deviceType: this.targetDeviceType,
              rfCommands: this.output.settings.rfCommands,
            }
          }
        });
        this.$store.commit('saveState');
        this.$router.push('/home/devices/');
        this.$store.commit('setAppBusy', false);
      }
    },
    deleteOutput: function () {
      this.$router.push('/deleteRfDevice/' + this.node.uuid + '/' + this.$route.params.outputIndex);
    },
  }
}
</script>

<style>
  .RfDeviceSettings-topCurve-wrapper {
    height: 200px;
  }
  .RfDeviceSettings-main {
    z-index: 2;
  }
  .RfDeviceSettings-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .RfDeviceSettings-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .RfDeviceSettings-wrapper-colors {
    height: 50px;
  }
  .RfDeviceSettings-color {
    width: calc((100% - 32px)/5);
    margin-left: 8px;
    padding: 5px;
  }
  .RfDeviceSettings-selectedColor {
    background-color: transparent;
    border-style: solid;
    border-color: #FFFFFF;
    border-width: 4px;
    opacity: 0;
  }
  .RfDeviceSettings-color.active .RfDeviceSettings-selectedColor {
    opacity: 1;
  }
  .RfDeviceSettings-color:last-child {
    width: calc((100% - 32px)/5);
    margin-left: 0;
  }
  .RfDeviceSettings-wrapper-name-text {
    height: 30px;
    line-height: 30px;
    color: #52626C;
  }
  .RfDeviceSettings-wrapper-fieldTitles {
    height: 30px;
    line-height: 30px;
    color: #52626C;
  }
  .RfDeviceSettings-wrapper-fieldText {
    margin-top: 14px;
    line-height: 20px;
    color: #52626C;
  }
  .RfDeviceSettings-wrapper-button {
    width: calc(100% - 36px);
    margin-top: 15px;
    margin-bottom: 14px;
  }
  .RfDeviceSettings-wrapper-commands {
    height: 70px;
    background-color: #FFFFFF;
    padding: 5px;
    margin-top: 14px;
  }
  .RfDeviceSettings-wrapper-commands:first-child {
    margin-top: 0;
  }
  .RfDeviceSettings-wrapper-command {
    height: 20px;
    line-height: 20px;
  }
  .RfDeviceSettings-wrapper-commands-trash {
    left: 5px;
    top: 5px;
    width: 30px;
    height: 30px;
  }
</style>
